module.exports = __webpack_public_path__ + "static/media/12C.950f3a6b.jpg";